import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Project } from '@src/types/shared/project';
import { nanoid } from 'nanoid';
import type { RootState } from '..';

type State = { projects: Project[] };

const initialState: State = { projects: [] };

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    addProject(state, action: PayloadAction<Omit<Project, 'id'>>) {
      state.projects.push({ ...action.payload, id: nanoid() });
    },
    updateProject(state, action: PayloadAction<{ index: number; item: Project }>) {
      const { index, item } = action.payload;
      if (index >= 0 && index < state.projects.length) {
        state.projects[index] = item;
      }
    },
    updateProjectsFromStorage(state, action: PayloadAction<Project[]>) {
      state.projects = action.payload;
    },
    removeProject(state, action: PayloadAction<number>) {
      state.projects.splice(action.payload, 1);
    },
    reorderProjects(state, action: PayloadAction<Project[]>) {
      state.projects = action.payload;
    },
  },
});

export const {
  addProject,
  updateProject,
  updateProjectsFromStorage,
  removeProject,
  reorderProjects,
} = projectSlice.actions;

export const selectProject = (state: RootState): Project[] => state.project.projects;

export default projectSlice.reducer;
